/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AuthorizeJitAccessBody,
  CreateRoleBody,
  CreateRoleResponse,
  DeleteRolesResponse,
  GetProjectDbMetadataResponse,
  JitAccessRequestRequest,
  JitAccessResponse,
  JitAuthorizeAccessResponse,
  JitListAccessResponse,
  PostgresConfigResponse,
  ReadOnlyStatusResponse,
  RemoveReadReplicaBody,
  SetUpReadReplicaBody,
  SnippetList,
  SnippetResponse,
  SslEnforcementRequest,
  SslEnforcementResponse,
  SupavisorConfigResponse,
  TypescriptResponse,
  UpdateJitAccessBody,
  UpdatePostgresConfigBody,
  UpdateSupavisorConfigBody,
  UpdateSupavisorConfigResponse,
  V1BackupsResponse,
  V1CreateMigrationBody,
  V1GenerateTypescriptTypesParams,
  V1GetMigrationResponse,
  V1GetRestorePointParams,
  V1ListAllSnippetsParams,
  V1ListMigrationsResponse,
  V1PatchMigrationBody,
  V1PgbouncerConfigResponse,
  V1ReadOnlyQueryBody,
  V1RestorePitrBody,
  V1RestorePointPostBody,
  V1RestorePointResponse,
  V1RollbackMigrationsParams,
  V1RunQueryBody,
  V1UndoBody,
  V1UpdatePasswordBody,
  V1UpdatePasswordResponse,
  V1UpsertMigrationBody
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * @summary Lists SQL snippets for the logged in user
 */
export type v1ListAllSnippetsResponse200 = {
  data: SnippetList
  status: 200
}

export type v1ListAllSnippetsResponse500 = {
  data: void
  status: 500
}

export type v1ListAllSnippetsResponseSuccess = (v1ListAllSnippetsResponse200) & {
  headers: Headers;
};
export type v1ListAllSnippetsResponseError = (v1ListAllSnippetsResponse500) & {
  headers: Headers;
};

export type v1ListAllSnippetsResponse = (v1ListAllSnippetsResponseSuccess | v1ListAllSnippetsResponseError)

export const getV1ListAllSnippetsUrl = (params?: V1ListAllSnippetsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/snippets?${stringifiedParams}` : `/v1/snippets`
}

export const v1ListAllSnippets = async (params?: V1ListAllSnippetsParams, options?: RequestInit): Promise<v1ListAllSnippetsResponse> => {
  
  return customFetch<v1ListAllSnippetsResponse>(getV1ListAllSnippetsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets a specific SQL snippet
 */
export type v1GetASnippetResponse200 = {
  data: SnippetResponse
  status: 200
}

export type v1GetASnippetResponse500 = {
  data: void
  status: 500
}

export type v1GetASnippetResponseSuccess = (v1GetASnippetResponse200) & {
  headers: Headers;
};
export type v1GetASnippetResponseError = (v1GetASnippetResponse500) & {
  headers: Headers;
};

export type v1GetASnippetResponse = (v1GetASnippetResponseSuccess | v1GetASnippetResponseError)

export const getV1GetASnippetUrl = (id: string,) => {


  

  return `/v1/snippets/${id}`
}

export const v1GetASnippet = async (id: string, options?: RequestInit): Promise<v1GetASnippetResponse> => {
  
  return customFetch<v1GetASnippetResponse>(getV1GetASnippetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Get project's just-in-time access configuration.
 */
export type v1GetJitAccessConfigResponse200 = {
  data: JitAccessResponse
  status: 200
}

export type v1GetJitAccessConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetJitAccessConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetJitAccessConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetJitAccessConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetJitAccessConfigResponseSuccess = (v1GetJitAccessConfigResponse200) & {
  headers: Headers;
};
export type v1GetJitAccessConfigResponseError = (v1GetJitAccessConfigResponse401 | v1GetJitAccessConfigResponse403 | v1GetJitAccessConfigResponse429 | v1GetJitAccessConfigResponse500) & {
  headers: Headers;
};

export type v1GetJitAccessConfigResponse = (v1GetJitAccessConfigResponseSuccess | v1GetJitAccessConfigResponseError)

export const getV1GetJitAccessConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/jit-access`
}

export const v1GetJitAccessConfig = async (ref: string, options?: RequestInit): Promise<v1GetJitAccessConfigResponse> => {
  
  return customFetch<v1GetJitAccessConfigResponse>(getV1GetJitAccessConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Update project's just-in-time access configuration.
 */
export type v1UpdateJitAccessConfigResponse200 = {
  data: JitAccessResponse
  status: 200
}

export type v1UpdateJitAccessConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdateJitAccessConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdateJitAccessConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdateJitAccessConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdateJitAccessConfigResponseSuccess = (v1UpdateJitAccessConfigResponse200) & {
  headers: Headers;
};
export type v1UpdateJitAccessConfigResponseError = (v1UpdateJitAccessConfigResponse401 | v1UpdateJitAccessConfigResponse403 | v1UpdateJitAccessConfigResponse429 | v1UpdateJitAccessConfigResponse500) & {
  headers: Headers;
};

export type v1UpdateJitAccessConfigResponse = (v1UpdateJitAccessConfigResponseSuccess | v1UpdateJitAccessConfigResponseError)

export const getV1UpdateJitAccessConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/jit-access`
}

export const v1UpdateJitAccessConfig = async (ref: string,
    jitAccessRequestRequest: JitAccessRequestRequest, options?: RequestInit): Promise<v1UpdateJitAccessConfigResponse> => {
  
  return customFetch<v1UpdateJitAccessConfigResponse>(getV1UpdateJitAccessConfigUrl(ref),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      jitAccessRequestRequest,)
  }
);}
  

/**
 * @summary [Beta] Get project's SSL enforcement configuration.
 */
export type v1GetSslEnforcementConfigResponse200 = {
  data: SslEnforcementResponse
  status: 200
}

export type v1GetSslEnforcementConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetSslEnforcementConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetSslEnforcementConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetSslEnforcementConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetSslEnforcementConfigResponseSuccess = (v1GetSslEnforcementConfigResponse200) & {
  headers: Headers;
};
export type v1GetSslEnforcementConfigResponseError = (v1GetSslEnforcementConfigResponse401 | v1GetSslEnforcementConfigResponse403 | v1GetSslEnforcementConfigResponse429 | v1GetSslEnforcementConfigResponse500) & {
  headers: Headers;
};

export type v1GetSslEnforcementConfigResponse = (v1GetSslEnforcementConfigResponseSuccess | v1GetSslEnforcementConfigResponseError)

export const getV1GetSslEnforcementConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/ssl-enforcement`
}

export const v1GetSslEnforcementConfig = async (ref: string, options?: RequestInit): Promise<v1GetSslEnforcementConfigResponse> => {
  
  return customFetch<v1GetSslEnforcementConfigResponse>(getV1GetSslEnforcementConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary [Beta] Update project's SSL enforcement configuration.
 */
export type v1UpdateSslEnforcementConfigResponse200 = {
  data: SslEnforcementResponse
  status: 200
}

export type v1UpdateSslEnforcementConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdateSslEnforcementConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdateSslEnforcementConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdateSslEnforcementConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdateSslEnforcementConfigResponseSuccess = (v1UpdateSslEnforcementConfigResponse200) & {
  headers: Headers;
};
export type v1UpdateSslEnforcementConfigResponseError = (v1UpdateSslEnforcementConfigResponse401 | v1UpdateSslEnforcementConfigResponse403 | v1UpdateSslEnforcementConfigResponse429 | v1UpdateSslEnforcementConfigResponse500) & {
  headers: Headers;
};

export type v1UpdateSslEnforcementConfigResponse = (v1UpdateSslEnforcementConfigResponseSuccess | v1UpdateSslEnforcementConfigResponseError)

export const getV1UpdateSslEnforcementConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/ssl-enforcement`
}

export const v1UpdateSslEnforcementConfig = async (ref: string,
    sslEnforcementRequest: SslEnforcementRequest, options?: RequestInit): Promise<v1UpdateSslEnforcementConfigResponse> => {
  
  return customFetch<v1UpdateSslEnforcementConfigResponse>(getV1UpdateSslEnforcementConfigUrl(ref),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sslEnforcementRequest,)
  }
);}
  

/**
 * Returns the TypeScript types of your schema for use with supabase-js.
 * @summary Generate TypeScript types
 */
export type v1GenerateTypescriptTypesResponse200 = {
  data: TypescriptResponse
  status: 200
}

export type v1GenerateTypescriptTypesResponse401 = {
  data: void
  status: 401
}

export type v1GenerateTypescriptTypesResponse403 = {
  data: void
  status: 403
}

export type v1GenerateTypescriptTypesResponse429 = {
  data: void
  status: 429
}

export type v1GenerateTypescriptTypesResponse500 = {
  data: void
  status: 500
}

export type v1GenerateTypescriptTypesResponseSuccess = (v1GenerateTypescriptTypesResponse200) & {
  headers: Headers;
};
export type v1GenerateTypescriptTypesResponseError = (v1GenerateTypescriptTypesResponse401 | v1GenerateTypescriptTypesResponse403 | v1GenerateTypescriptTypesResponse429 | v1GenerateTypescriptTypesResponse500) & {
  headers: Headers;
};

export type v1GenerateTypescriptTypesResponse = (v1GenerateTypescriptTypesResponseSuccess | v1GenerateTypescriptTypesResponseError)

export const getV1GenerateTypescriptTypesUrl = (ref: string,
    params?: V1GenerateTypescriptTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/types/typescript?${stringifiedParams}` : `/v1/projects/${ref}/types/typescript`
}

export const v1GenerateTypescriptTypes = async (ref: string,
    params?: V1GenerateTypescriptTypesParams, options?: RequestInit): Promise<v1GenerateTypescriptTypesResponse> => {
  
  return customFetch<v1GenerateTypescriptTypesResponse>(getV1GenerateTypescriptTypesUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Returns project's readonly mode status
 */
export type v1GetReadonlyModeStatusResponse200 = {
  data: ReadOnlyStatusResponse
  status: 200
}

export type v1GetReadonlyModeStatusResponse401 = {
  data: void
  status: 401
}

export type v1GetReadonlyModeStatusResponse403 = {
  data: void
  status: 403
}

export type v1GetReadonlyModeStatusResponse429 = {
  data: void
  status: 429
}

export type v1GetReadonlyModeStatusResponse500 = {
  data: void
  status: 500
}

export type v1GetReadonlyModeStatusResponseSuccess = (v1GetReadonlyModeStatusResponse200) & {
  headers: Headers;
};
export type v1GetReadonlyModeStatusResponseError = (v1GetReadonlyModeStatusResponse401 | v1GetReadonlyModeStatusResponse403 | v1GetReadonlyModeStatusResponse429 | v1GetReadonlyModeStatusResponse500) & {
  headers: Headers;
};

export type v1GetReadonlyModeStatusResponse = (v1GetReadonlyModeStatusResponseSuccess | v1GetReadonlyModeStatusResponseError)

export const getV1GetReadonlyModeStatusUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/readonly`
}

export const v1GetReadonlyModeStatus = async (ref: string, options?: RequestInit): Promise<v1GetReadonlyModeStatusResponse> => {
  
  return customFetch<v1GetReadonlyModeStatusResponse>(getV1GetReadonlyModeStatusUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Disables project's readonly mode for the next 15 minutes
 */
export type v1DisableReadonlyModeTemporarilyResponse201 = {
  data: void
  status: 201
}

export type v1DisableReadonlyModeTemporarilyResponse401 = {
  data: void
  status: 401
}

export type v1DisableReadonlyModeTemporarilyResponse403 = {
  data: void
  status: 403
}

export type v1DisableReadonlyModeTemporarilyResponse429 = {
  data: void
  status: 429
}

export type v1DisableReadonlyModeTemporarilyResponse500 = {
  data: void
  status: 500
}

export type v1DisableReadonlyModeTemporarilyResponseSuccess = (v1DisableReadonlyModeTemporarilyResponse201) & {
  headers: Headers;
};
export type v1DisableReadonlyModeTemporarilyResponseError = (v1DisableReadonlyModeTemporarilyResponse401 | v1DisableReadonlyModeTemporarilyResponse403 | v1DisableReadonlyModeTemporarilyResponse429 | v1DisableReadonlyModeTemporarilyResponse500) & {
  headers: Headers;
};

export type v1DisableReadonlyModeTemporarilyResponse = (v1DisableReadonlyModeTemporarilyResponseSuccess | v1DisableReadonlyModeTemporarilyResponseError)

export const getV1DisableReadonlyModeTemporarilyUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/readonly/temporary-disable`
}

export const v1DisableReadonlyModeTemporarily = async (ref: string, options?: RequestInit): Promise<v1DisableReadonlyModeTemporarilyResponse> => {
  
  return customFetch<v1DisableReadonlyModeTemporarilyResponse>(getV1DisableReadonlyModeTemporarilyUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary [Beta] Set up a read replica
 */
export type v1SetupAReadReplicaResponse201 = {
  data: void
  status: 201
}

export type v1SetupAReadReplicaResponse401 = {
  data: void
  status: 401
}

export type v1SetupAReadReplicaResponse403 = {
  data: void
  status: 403
}

export type v1SetupAReadReplicaResponse429 = {
  data: void
  status: 429
}

export type v1SetupAReadReplicaResponse500 = {
  data: void
  status: 500
}

export type v1SetupAReadReplicaResponseSuccess = (v1SetupAReadReplicaResponse201) & {
  headers: Headers;
};
export type v1SetupAReadReplicaResponseError = (v1SetupAReadReplicaResponse401 | v1SetupAReadReplicaResponse403 | v1SetupAReadReplicaResponse429 | v1SetupAReadReplicaResponse500) & {
  headers: Headers;
};

export type v1SetupAReadReplicaResponse = (v1SetupAReadReplicaResponseSuccess | v1SetupAReadReplicaResponseError)

export const getV1SetupAReadReplicaUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/read-replicas/setup`
}

export const v1SetupAReadReplica = async (ref: string,
    setUpReadReplicaBody: SetUpReadReplicaBody, options?: RequestInit): Promise<v1SetupAReadReplicaResponse> => {
  
  return customFetch<v1SetupAReadReplicaResponse>(getV1SetupAReadReplicaUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setUpReadReplicaBody,)
  }
);}
  

/**
 * @summary [Beta] Remove a read replica
 */
export type v1RemoveAReadReplicaResponse201 = {
  data: void
  status: 201
}

export type v1RemoveAReadReplicaResponse401 = {
  data: void
  status: 401
}

export type v1RemoveAReadReplicaResponse403 = {
  data: void
  status: 403
}

export type v1RemoveAReadReplicaResponse429 = {
  data: void
  status: 429
}

export type v1RemoveAReadReplicaResponse500 = {
  data: void
  status: 500
}

export type v1RemoveAReadReplicaResponseSuccess = (v1RemoveAReadReplicaResponse201) & {
  headers: Headers;
};
export type v1RemoveAReadReplicaResponseError = (v1RemoveAReadReplicaResponse401 | v1RemoveAReadReplicaResponse403 | v1RemoveAReadReplicaResponse429 | v1RemoveAReadReplicaResponse500) & {
  headers: Headers;
};

export type v1RemoveAReadReplicaResponse = (v1RemoveAReadReplicaResponseSuccess | v1RemoveAReadReplicaResponseError)

export const getV1RemoveAReadReplicaUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/read-replicas/remove`
}

export const v1RemoveAReadReplica = async (ref: string,
    removeReadReplicaBody: RemoveReadReplicaBody, options?: RequestInit): Promise<v1RemoveAReadReplicaResponse> => {
  
  return customFetch<v1RemoveAReadReplicaResponse>(getV1RemoveAReadReplicaUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      removeReadReplicaBody,)
  }
);}
  

/**
 * @summary [Beta] Create a login role for CLI with temporary password
 */
export type v1CreateLoginRoleResponse201 = {
  data: CreateRoleResponse
  status: 201
}

export type v1CreateLoginRoleResponse401 = {
  data: void
  status: 401
}

export type v1CreateLoginRoleResponse403 = {
  data: void
  status: 403
}

export type v1CreateLoginRoleResponse429 = {
  data: void
  status: 429
}

export type v1CreateLoginRoleResponse500 = {
  data: void
  status: 500
}

export type v1CreateLoginRoleResponseSuccess = (v1CreateLoginRoleResponse201) & {
  headers: Headers;
};
export type v1CreateLoginRoleResponseError = (v1CreateLoginRoleResponse401 | v1CreateLoginRoleResponse403 | v1CreateLoginRoleResponse429 | v1CreateLoginRoleResponse500) & {
  headers: Headers;
};

export type v1CreateLoginRoleResponse = (v1CreateLoginRoleResponseSuccess | v1CreateLoginRoleResponseError)

export const getV1CreateLoginRoleUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/cli/login-role`
}

export const v1CreateLoginRole = async (ref: string,
    createRoleBody: CreateRoleBody, options?: RequestInit): Promise<v1CreateLoginRoleResponse> => {
  
  return customFetch<v1CreateLoginRoleResponse>(getV1CreateLoginRoleUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createRoleBody,)
  }
);}
  

/**
 * @summary [Beta] Delete existing login roles used by CLI
 */
export type v1DeleteLoginRolesResponse200 = {
  data: DeleteRolesResponse
  status: 200
}

export type v1DeleteLoginRolesResponse401 = {
  data: void
  status: 401
}

export type v1DeleteLoginRolesResponse403 = {
  data: void
  status: 403
}

export type v1DeleteLoginRolesResponse429 = {
  data: void
  status: 429
}

export type v1DeleteLoginRolesResponse500 = {
  data: void
  status: 500
}

export type v1DeleteLoginRolesResponseSuccess = (v1DeleteLoginRolesResponse200) & {
  headers: Headers;
};
export type v1DeleteLoginRolesResponseError = (v1DeleteLoginRolesResponse401 | v1DeleteLoginRolesResponse403 | v1DeleteLoginRolesResponse429 | v1DeleteLoginRolesResponse500) & {
  headers: Headers;
};

export type v1DeleteLoginRolesResponse = (v1DeleteLoginRolesResponseSuccess | v1DeleteLoginRolesResponseError)

export const getV1DeleteLoginRolesUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/cli/login-role`
}

export const v1DeleteLoginRoles = async (ref: string, options?: RequestInit): Promise<v1DeleteLoginRolesResponse> => {
  
  return customFetch<v1DeleteLoginRolesResponse>(getV1DeleteLoginRolesUrl(ref),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Only available to selected partner OAuth apps
 * @summary [Beta] List applied migration versions
 */
export type v1ListMigrationHistoryResponse200 = {
  data: V1ListMigrationsResponse
  status: 200
}

export type v1ListMigrationHistoryResponse401 = {
  data: void
  status: 401
}

export type v1ListMigrationHistoryResponse403 = {
  data: void
  status: 403
}

export type v1ListMigrationHistoryResponse429 = {
  data: void
  status: 429
}

export type v1ListMigrationHistoryResponse500 = {
  data: void
  status: 500
}

export type v1ListMigrationHistoryResponseSuccess = (v1ListMigrationHistoryResponse200) & {
  headers: Headers;
};
export type v1ListMigrationHistoryResponseError = (v1ListMigrationHistoryResponse401 | v1ListMigrationHistoryResponse403 | v1ListMigrationHistoryResponse429 | v1ListMigrationHistoryResponse500) & {
  headers: Headers;
};

export type v1ListMigrationHistoryResponse = (v1ListMigrationHistoryResponseSuccess | v1ListMigrationHistoryResponseError)

export const getV1ListMigrationHistoryUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/migrations`
}

export const v1ListMigrationHistory = async (ref: string, options?: RequestInit): Promise<v1ListMigrationHistoryResponse> => {
  
  return customFetch<v1ListMigrationHistoryResponse>(getV1ListMigrationHistoryUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Only available to selected partner OAuth apps
 * @summary [Beta] Apply a database migration
 */
export type v1ApplyAMigrationResponse200 = {
  data: void
  status: 200
}

export type v1ApplyAMigrationResponse401 = {
  data: void
  status: 401
}

export type v1ApplyAMigrationResponse403 = {
  data: void
  status: 403
}

export type v1ApplyAMigrationResponse429 = {
  data: void
  status: 429
}

export type v1ApplyAMigrationResponse500 = {
  data: void
  status: 500
}

export type v1ApplyAMigrationResponseSuccess = (v1ApplyAMigrationResponse200) & {
  headers: Headers;
};
export type v1ApplyAMigrationResponseError = (v1ApplyAMigrationResponse401 | v1ApplyAMigrationResponse403 | v1ApplyAMigrationResponse429 | v1ApplyAMigrationResponse500) & {
  headers: Headers;
};

export type v1ApplyAMigrationResponse = (v1ApplyAMigrationResponseSuccess | v1ApplyAMigrationResponseError)

export const getV1ApplyAMigrationUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/migrations`
}

export const v1ApplyAMigration = async (ref: string,
    v1CreateMigrationBody: V1CreateMigrationBody, options?: RequestInit): Promise<v1ApplyAMigrationResponse> => {
  
  return customFetch<v1ApplyAMigrationResponse>(getV1ApplyAMigrationUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1CreateMigrationBody,)
  }
);}
  

/**
 * Only available to selected partner OAuth apps
 * @summary [Beta] Upsert a database migration without applying
 */
export type v1UpsertAMigrationResponse200 = {
  data: void
  status: 200
}

export type v1UpsertAMigrationResponse401 = {
  data: void
  status: 401
}

export type v1UpsertAMigrationResponse403 = {
  data: void
  status: 403
}

export type v1UpsertAMigrationResponse429 = {
  data: void
  status: 429
}

export type v1UpsertAMigrationResponse500 = {
  data: void
  status: 500
}

export type v1UpsertAMigrationResponseSuccess = (v1UpsertAMigrationResponse200) & {
  headers: Headers;
};
export type v1UpsertAMigrationResponseError = (v1UpsertAMigrationResponse401 | v1UpsertAMigrationResponse403 | v1UpsertAMigrationResponse429 | v1UpsertAMigrationResponse500) & {
  headers: Headers;
};

export type v1UpsertAMigrationResponse = (v1UpsertAMigrationResponseSuccess | v1UpsertAMigrationResponseError)

export const getV1UpsertAMigrationUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/migrations`
}

export const v1UpsertAMigration = async (ref: string,
    v1UpsertMigrationBody: V1UpsertMigrationBody, options?: RequestInit): Promise<v1UpsertAMigrationResponse> => {
  
  return customFetch<v1UpsertAMigrationResponse>(getV1UpsertAMigrationUrl(ref),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1UpsertMigrationBody,)
  }
);}
  

/**
 * Only available to selected partner OAuth apps
 * @summary [Beta] Rollback database migrations and remove them from history table
 */
export type v1RollbackMigrationsResponse200 = {
  data: void
  status: 200
}

export type v1RollbackMigrationsResponse401 = {
  data: void
  status: 401
}

export type v1RollbackMigrationsResponse403 = {
  data: void
  status: 403
}

export type v1RollbackMigrationsResponse429 = {
  data: void
  status: 429
}

export type v1RollbackMigrationsResponse500 = {
  data: void
  status: 500
}

export type v1RollbackMigrationsResponseSuccess = (v1RollbackMigrationsResponse200) & {
  headers: Headers;
};
export type v1RollbackMigrationsResponseError = (v1RollbackMigrationsResponse401 | v1RollbackMigrationsResponse403 | v1RollbackMigrationsResponse429 | v1RollbackMigrationsResponse500) & {
  headers: Headers;
};

export type v1RollbackMigrationsResponse = (v1RollbackMigrationsResponseSuccess | v1RollbackMigrationsResponseError)

export const getV1RollbackMigrationsUrl = (ref: string,
    params: V1RollbackMigrationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/database/migrations?${stringifiedParams}` : `/v1/projects/${ref}/database/migrations`
}

export const v1RollbackMigrations = async (ref: string,
    params: V1RollbackMigrationsParams, options?: RequestInit): Promise<v1RollbackMigrationsResponse> => {
  
  return customFetch<v1RollbackMigrationsResponse>(getV1RollbackMigrationsUrl(ref,params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * Only available to selected partner OAuth apps
 * @summary [Beta] Fetch an existing entry from migration history
 */
export type v1GetAMigrationResponse200 = {
  data: V1GetMigrationResponse
  status: 200
}

export type v1GetAMigrationResponse401 = {
  data: void
  status: 401
}

export type v1GetAMigrationResponse403 = {
  data: void
  status: 403
}

export type v1GetAMigrationResponse429 = {
  data: void
  status: 429
}

export type v1GetAMigrationResponse500 = {
  data: void
  status: 500
}

export type v1GetAMigrationResponseSuccess = (v1GetAMigrationResponse200) & {
  headers: Headers;
};
export type v1GetAMigrationResponseError = (v1GetAMigrationResponse401 | v1GetAMigrationResponse403 | v1GetAMigrationResponse429 | v1GetAMigrationResponse500) & {
  headers: Headers;
};

export type v1GetAMigrationResponse = (v1GetAMigrationResponseSuccess | v1GetAMigrationResponseError)

export const getV1GetAMigrationUrl = (ref: string,
    version: string,) => {


  

  return `/v1/projects/${ref}/database/migrations/${version}`
}

export const v1GetAMigration = async (ref: string,
    version: string, options?: RequestInit): Promise<v1GetAMigrationResponse> => {
  
  return customFetch<v1GetAMigrationResponse>(getV1GetAMigrationUrl(ref,version),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Only available to selected partner OAuth apps
 * @summary [Beta] Patch an existing entry in migration history
 */
export type v1PatchAMigrationResponse200 = {
  data: void
  status: 200
}

export type v1PatchAMigrationResponse401 = {
  data: void
  status: 401
}

export type v1PatchAMigrationResponse403 = {
  data: void
  status: 403
}

export type v1PatchAMigrationResponse429 = {
  data: void
  status: 429
}

export type v1PatchAMigrationResponse500 = {
  data: void
  status: 500
}

export type v1PatchAMigrationResponseSuccess = (v1PatchAMigrationResponse200) & {
  headers: Headers;
};
export type v1PatchAMigrationResponseError = (v1PatchAMigrationResponse401 | v1PatchAMigrationResponse403 | v1PatchAMigrationResponse429 | v1PatchAMigrationResponse500) & {
  headers: Headers;
};

export type v1PatchAMigrationResponse = (v1PatchAMigrationResponseSuccess | v1PatchAMigrationResponseError)

export const getV1PatchAMigrationUrl = (ref: string,
    version: string,) => {


  

  return `/v1/projects/${ref}/database/migrations/${version}`
}

export const v1PatchAMigration = async (ref: string,
    version: string,
    v1PatchMigrationBody: V1PatchMigrationBody, options?: RequestInit): Promise<v1PatchAMigrationResponse> => {
  
  return customFetch<v1PatchAMigrationResponse>(getV1PatchAMigrationUrl(ref,version),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1PatchMigrationBody,)
  }
);}
  

/**
 * @summary [Beta] Run sql query
 */
export type v1RunAQueryResponse201 = {
  data: void
  status: 201
}

export type v1RunAQueryResponse401 = {
  data: void
  status: 401
}

export type v1RunAQueryResponse403 = {
  data: void
  status: 403
}

export type v1RunAQueryResponse429 = {
  data: void
  status: 429
}

export type v1RunAQueryResponse500 = {
  data: void
  status: 500
}

export type v1RunAQueryResponseSuccess = (v1RunAQueryResponse201) & {
  headers: Headers;
};
export type v1RunAQueryResponseError = (v1RunAQueryResponse401 | v1RunAQueryResponse403 | v1RunAQueryResponse429 | v1RunAQueryResponse500) & {
  headers: Headers;
};

export type v1RunAQueryResponse = (v1RunAQueryResponseSuccess | v1RunAQueryResponseError)

export const getV1RunAQueryUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/query`
}

export const v1RunAQuery = async (ref: string,
    v1RunQueryBody: V1RunQueryBody, options?: RequestInit): Promise<v1RunAQueryResponse> => {
  
  return customFetch<v1RunAQueryResponse>(getV1RunAQueryUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1RunQueryBody,)
  }
);}
  

/**
 * All entity references must be schema qualified.
 * @summary [Beta] Run a sql query as supabase_read_only_user
 */
export type v1ReadOnlyQueryResponse201 = {
  data: void
  status: 201
}

export type v1ReadOnlyQueryResponse401 = {
  data: void
  status: 401
}

export type v1ReadOnlyQueryResponse403 = {
  data: void
  status: 403
}

export type v1ReadOnlyQueryResponse429 = {
  data: void
  status: 429
}

export type v1ReadOnlyQueryResponse500 = {
  data: void
  status: 500
}

export type v1ReadOnlyQueryResponseSuccess = (v1ReadOnlyQueryResponse201) & {
  headers: Headers;
};
export type v1ReadOnlyQueryResponseError = (v1ReadOnlyQueryResponse401 | v1ReadOnlyQueryResponse403 | v1ReadOnlyQueryResponse429 | v1ReadOnlyQueryResponse500) & {
  headers: Headers;
};

export type v1ReadOnlyQueryResponse = (v1ReadOnlyQueryResponseSuccess | v1ReadOnlyQueryResponseError)

export const getV1ReadOnlyQueryUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/query/read-only`
}

export const v1ReadOnlyQuery = async (ref: string,
    v1ReadOnlyQueryBody: V1ReadOnlyQueryBody, options?: RequestInit): Promise<v1ReadOnlyQueryResponse> => {
  
  return customFetch<v1ReadOnlyQueryResponse>(getV1ReadOnlyQueryUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1ReadOnlyQueryBody,)
  }
);}
  

/**
 * @summary [Beta] Enables Database Webhooks on the project
 */
export type v1EnableDatabaseWebhookResponse201 = {
  data: void
  status: 201
}

export type v1EnableDatabaseWebhookResponse401 = {
  data: void
  status: 401
}

export type v1EnableDatabaseWebhookResponse403 = {
  data: void
  status: 403
}

export type v1EnableDatabaseWebhookResponse429 = {
  data: void
  status: 429
}

export type v1EnableDatabaseWebhookResponse500 = {
  data: void
  status: 500
}

export type v1EnableDatabaseWebhookResponseSuccess = (v1EnableDatabaseWebhookResponse201) & {
  headers: Headers;
};
export type v1EnableDatabaseWebhookResponseError = (v1EnableDatabaseWebhookResponse401 | v1EnableDatabaseWebhookResponse403 | v1EnableDatabaseWebhookResponse429 | v1EnableDatabaseWebhookResponse500) & {
  headers: Headers;
};

export type v1EnableDatabaseWebhookResponse = (v1EnableDatabaseWebhookResponseSuccess | v1EnableDatabaseWebhookResponseError)

export const getV1EnableDatabaseWebhookUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/webhooks/enable`
}

export const v1EnableDatabaseWebhook = async (ref: string, options?: RequestInit): Promise<v1EnableDatabaseWebhookResponse> => {
  
  return customFetch<v1EnableDatabaseWebhookResponse>(getV1EnableDatabaseWebhookUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * This is an **experimental** endpoint. It is subject to change or removal in future versions. Use it with caution, as it may not remain supported or stable.
 * @deprecated
 * @summary Gets database metadata for the given project.
 */
export type v1GetDatabaseMetadataResponse200 = {
  data: GetProjectDbMetadataResponse
  status: 200
}

export type v1GetDatabaseMetadataResponse401 = {
  data: void
  status: 401
}

export type v1GetDatabaseMetadataResponse403 = {
  data: void
  status: 403
}

export type v1GetDatabaseMetadataResponse429 = {
  data: void
  status: 429
}

export type v1GetDatabaseMetadataResponseSuccess = (v1GetDatabaseMetadataResponse200) & {
  headers: Headers;
};
export type v1GetDatabaseMetadataResponseError = (v1GetDatabaseMetadataResponse401 | v1GetDatabaseMetadataResponse403 | v1GetDatabaseMetadataResponse429) & {
  headers: Headers;
};

export type v1GetDatabaseMetadataResponse = (v1GetDatabaseMetadataResponseSuccess | v1GetDatabaseMetadataResponseError)

export const getV1GetDatabaseMetadataUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/context`
}

export const v1GetDatabaseMetadata = async (ref: string, options?: RequestInit): Promise<v1GetDatabaseMetadataResponse> => {
  
  return customFetch<v1GetDatabaseMetadataResponse>(getV1GetDatabaseMetadataUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates the database password
 */
export type v1UpdateDatabasePasswordResponse200 = {
  data: V1UpdatePasswordResponse
  status: 200
}

export type v1UpdateDatabasePasswordResponse401 = {
  data: void
  status: 401
}

export type v1UpdateDatabasePasswordResponse403 = {
  data: void
  status: 403
}

export type v1UpdateDatabasePasswordResponse429 = {
  data: void
  status: 429
}

export type v1UpdateDatabasePasswordResponse500 = {
  data: void
  status: 500
}

export type v1UpdateDatabasePasswordResponseSuccess = (v1UpdateDatabasePasswordResponse200) & {
  headers: Headers;
};
export type v1UpdateDatabasePasswordResponseError = (v1UpdateDatabasePasswordResponse401 | v1UpdateDatabasePasswordResponse403 | v1UpdateDatabasePasswordResponse429 | v1UpdateDatabasePasswordResponse500) & {
  headers: Headers;
};

export type v1UpdateDatabasePasswordResponse = (v1UpdateDatabasePasswordResponseSuccess | v1UpdateDatabasePasswordResponseError)

export const getV1UpdateDatabasePasswordUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/password`
}

export const v1UpdateDatabasePassword = async (ref: string,
    v1UpdatePasswordBody: V1UpdatePasswordBody, options?: RequestInit): Promise<v1UpdateDatabasePasswordResponse> => {
  
  return customFetch<v1UpdateDatabasePasswordResponse>(getV1UpdateDatabasePasswordUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1UpdatePasswordBody,)
  }
);}
  

/**
 * Mappings of roles a user can assume in the project database
 * @summary Get user-id to role mappings for JIT access
 */
export type v1GetJitAccessResponse200 = {
  data: JitAccessResponse
  status: 200
}

export type v1GetJitAccessResponse401 = {
  data: void
  status: 401
}

export type v1GetJitAccessResponse403 = {
  data: void
  status: 403
}

export type v1GetJitAccessResponse429 = {
  data: void
  status: 429
}

export type v1GetJitAccessResponse500 = {
  data: void
  status: 500
}

export type v1GetJitAccessResponseSuccess = (v1GetJitAccessResponse200) & {
  headers: Headers;
};
export type v1GetJitAccessResponseError = (v1GetJitAccessResponse401 | v1GetJitAccessResponse403 | v1GetJitAccessResponse429 | v1GetJitAccessResponse500) & {
  headers: Headers;
};

export type v1GetJitAccessResponse = (v1GetJitAccessResponseSuccess | v1GetJitAccessResponseError)

export const getV1GetJitAccessUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/jit`
}

export const v1GetJitAccess = async (ref: string, options?: RequestInit): Promise<v1GetJitAccessResponse> => {
  
  return customFetch<v1GetJitAccessResponse>(getV1GetJitAccessUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Authorizes the request to assume a role in the project database
 * @summary Authorize user-id to role mappings for JIT access
 */
export type v1AuthorizeJitAccessResponse200 = {
  data: JitAuthorizeAccessResponse
  status: 200
}

export type v1AuthorizeJitAccessResponse401 = {
  data: void
  status: 401
}

export type v1AuthorizeJitAccessResponse403 = {
  data: void
  status: 403
}

export type v1AuthorizeJitAccessResponse429 = {
  data: void
  status: 429
}

export type v1AuthorizeJitAccessResponse500 = {
  data: void
  status: 500
}

export type v1AuthorizeJitAccessResponseSuccess = (v1AuthorizeJitAccessResponse200) & {
  headers: Headers;
};
export type v1AuthorizeJitAccessResponseError = (v1AuthorizeJitAccessResponse401 | v1AuthorizeJitAccessResponse403 | v1AuthorizeJitAccessResponse429 | v1AuthorizeJitAccessResponse500) & {
  headers: Headers;
};

export type v1AuthorizeJitAccessResponse = (v1AuthorizeJitAccessResponseSuccess | v1AuthorizeJitAccessResponseError)

export const getV1AuthorizeJitAccessUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/jit`
}

export const v1AuthorizeJitAccess = async (ref: string,
    authorizeJitAccessBody: AuthorizeJitAccessBody, options?: RequestInit): Promise<v1AuthorizeJitAccessResponse> => {
  
  return customFetch<v1AuthorizeJitAccessResponse>(getV1AuthorizeJitAccessUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authorizeJitAccessBody,)
  }
);}
  

/**
 * Modifies the roles that can be assumed and for how long
 * @summary Updates a user mapping for JIT access
 */
export type v1UpdateJitAccessResponse200 = {
  data: JitAccessResponse
  status: 200
}

export type v1UpdateJitAccessResponse401 = {
  data: void
  status: 401
}

export type v1UpdateJitAccessResponse403 = {
  data: void
  status: 403
}

export type v1UpdateJitAccessResponse429 = {
  data: void
  status: 429
}

export type v1UpdateJitAccessResponse500 = {
  data: void
  status: 500
}

export type v1UpdateJitAccessResponseSuccess = (v1UpdateJitAccessResponse200) & {
  headers: Headers;
};
export type v1UpdateJitAccessResponseError = (v1UpdateJitAccessResponse401 | v1UpdateJitAccessResponse403 | v1UpdateJitAccessResponse429 | v1UpdateJitAccessResponse500) & {
  headers: Headers;
};

export type v1UpdateJitAccessResponse = (v1UpdateJitAccessResponseSuccess | v1UpdateJitAccessResponseError)

export const getV1UpdateJitAccessUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/jit`
}

export const v1UpdateJitAccess = async (ref: string,
    updateJitAccessBody: UpdateJitAccessBody, options?: RequestInit): Promise<v1UpdateJitAccessResponse> => {
  
  return customFetch<v1UpdateJitAccessResponse>(getV1UpdateJitAccessUrl(ref),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateJitAccessBody,)
  }
);}
  

/**
 * Mappings of roles a user can assume in the project database
 * @summary List all user-id to role mappings for JIT access
 */
export type v1ListJitAccessResponse200 = {
  data: JitListAccessResponse
  status: 200
}

export type v1ListJitAccessResponse401 = {
  data: void
  status: 401
}

export type v1ListJitAccessResponse403 = {
  data: void
  status: 403
}

export type v1ListJitAccessResponse429 = {
  data: void
  status: 429
}

export type v1ListJitAccessResponse500 = {
  data: void
  status: 500
}

export type v1ListJitAccessResponseSuccess = (v1ListJitAccessResponse200) & {
  headers: Headers;
};
export type v1ListJitAccessResponseError = (v1ListJitAccessResponse401 | v1ListJitAccessResponse403 | v1ListJitAccessResponse429 | v1ListJitAccessResponse500) & {
  headers: Headers;
};

export type v1ListJitAccessResponse = (v1ListJitAccessResponseSuccess | v1ListJitAccessResponseError)

export const getV1ListJitAccessUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/jit/list`
}

export const v1ListJitAccess = async (ref: string, options?: RequestInit): Promise<v1ListJitAccessResponse> => {
  
  return customFetch<v1ListJitAccessResponse>(getV1ListJitAccessUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Remove JIT mappings of a user, revoking all JIT database access
 * @summary Delete JIT access by user-id
 */
export type v1DeleteJitAccessResponse200 = {
  data: void
  status: 200
}

export type v1DeleteJitAccessResponse401 = {
  data: void
  status: 401
}

export type v1DeleteJitAccessResponse403 = {
  data: void
  status: 403
}

export type v1DeleteJitAccessResponse429 = {
  data: void
  status: 429
}

export type v1DeleteJitAccessResponse500 = {
  data: void
  status: 500
}

export type v1DeleteJitAccessResponseSuccess = (v1DeleteJitAccessResponse200) & {
  headers: Headers;
};
export type v1DeleteJitAccessResponseError = (v1DeleteJitAccessResponse401 | v1DeleteJitAccessResponse403 | v1DeleteJitAccessResponse429 | v1DeleteJitAccessResponse500) & {
  headers: Headers;
};

export type v1DeleteJitAccessResponse = (v1DeleteJitAccessResponseSuccess | v1DeleteJitAccessResponseError)

export const getV1DeleteJitAccessUrl = (ref: string,
    userId: string,) => {


  

  return `/v1/projects/${ref}/database/jit/${userId}`
}

export const v1DeleteJitAccess = async (ref: string,
    userId: string, options?: RequestInit): Promise<v1DeleteJitAccessResponse> => {
  
  return customFetch<v1DeleteJitAccessResponse>(getV1DeleteJitAccessUrl(ref,userId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary Get project's pgbouncer config
 */
export type v1GetProjectPgbouncerConfigResponse200 = {
  data: V1PgbouncerConfigResponse
  status: 200
}

export type v1GetProjectPgbouncerConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectPgbouncerConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectPgbouncerConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectPgbouncerConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetProjectPgbouncerConfigResponseSuccess = (v1GetProjectPgbouncerConfigResponse200) & {
  headers: Headers;
};
export type v1GetProjectPgbouncerConfigResponseError = (v1GetProjectPgbouncerConfigResponse401 | v1GetProjectPgbouncerConfigResponse403 | v1GetProjectPgbouncerConfigResponse429 | v1GetProjectPgbouncerConfigResponse500) & {
  headers: Headers;
};

export type v1GetProjectPgbouncerConfigResponse = (v1GetProjectPgbouncerConfigResponseSuccess | v1GetProjectPgbouncerConfigResponseError)

export const getV1GetProjectPgbouncerConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/database/pgbouncer`
}

export const v1GetProjectPgbouncerConfig = async (ref: string, options?: RequestInit): Promise<v1GetProjectPgbouncerConfigResponse> => {
  
  return customFetch<v1GetProjectPgbouncerConfigResponse>(getV1GetProjectPgbouncerConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets project's supavisor config
 */
export type v1GetPoolerConfigResponse200 = {
  data: SupavisorConfigResponse[]
  status: 200
}

export type v1GetPoolerConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetPoolerConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetPoolerConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetPoolerConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetPoolerConfigResponseSuccess = (v1GetPoolerConfigResponse200) & {
  headers: Headers;
};
export type v1GetPoolerConfigResponseError = (v1GetPoolerConfigResponse401 | v1GetPoolerConfigResponse403 | v1GetPoolerConfigResponse429 | v1GetPoolerConfigResponse500) & {
  headers: Headers;
};

export type v1GetPoolerConfigResponse = (v1GetPoolerConfigResponseSuccess | v1GetPoolerConfigResponseError)

export const getV1GetPoolerConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/database/pooler`
}

export const v1GetPoolerConfig = async (ref: string, options?: RequestInit): Promise<v1GetPoolerConfigResponse> => {
  
  return customFetch<v1GetPoolerConfigResponse>(getV1GetPoolerConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates project's supavisor config
 */
export type v1UpdatePoolerConfigResponse200 = {
  data: UpdateSupavisorConfigResponse
  status: 200
}

export type v1UpdatePoolerConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdatePoolerConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdatePoolerConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdatePoolerConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdatePoolerConfigResponseSuccess = (v1UpdatePoolerConfigResponse200) & {
  headers: Headers;
};
export type v1UpdatePoolerConfigResponseError = (v1UpdatePoolerConfigResponse401 | v1UpdatePoolerConfigResponse403 | v1UpdatePoolerConfigResponse429 | v1UpdatePoolerConfigResponse500) & {
  headers: Headers;
};

export type v1UpdatePoolerConfigResponse = (v1UpdatePoolerConfigResponseSuccess | v1UpdatePoolerConfigResponseError)

export const getV1UpdatePoolerConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/database/pooler`
}

export const v1UpdatePoolerConfig = async (ref: string,
    updateSupavisorConfigBody: UpdateSupavisorConfigBody, options?: RequestInit): Promise<v1UpdatePoolerConfigResponse> => {
  
  return customFetch<v1UpdatePoolerConfigResponse>(getV1UpdatePoolerConfigUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSupavisorConfigBody,)
  }
);}
  

/**
 * @summary Gets project's Postgres config
 */
export type v1GetPostgresConfigResponse200 = {
  data: PostgresConfigResponse
  status: 200
}

export type v1GetPostgresConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetPostgresConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetPostgresConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetPostgresConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetPostgresConfigResponseSuccess = (v1GetPostgresConfigResponse200) & {
  headers: Headers;
};
export type v1GetPostgresConfigResponseError = (v1GetPostgresConfigResponse401 | v1GetPostgresConfigResponse403 | v1GetPostgresConfigResponse429 | v1GetPostgresConfigResponse500) & {
  headers: Headers;
};

export type v1GetPostgresConfigResponse = (v1GetPostgresConfigResponseSuccess | v1GetPostgresConfigResponseError)

export const getV1GetPostgresConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/database/postgres`
}

export const v1GetPostgresConfig = async (ref: string, options?: RequestInit): Promise<v1GetPostgresConfigResponse> => {
  
  return customFetch<v1GetPostgresConfigResponse>(getV1GetPostgresConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates project's Postgres config
 */
export type v1UpdatePostgresConfigResponse200 = {
  data: PostgresConfigResponse
  status: 200
}

export type v1UpdatePostgresConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdatePostgresConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdatePostgresConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdatePostgresConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdatePostgresConfigResponseSuccess = (v1UpdatePostgresConfigResponse200) & {
  headers: Headers;
};
export type v1UpdatePostgresConfigResponseError = (v1UpdatePostgresConfigResponse401 | v1UpdatePostgresConfigResponse403 | v1UpdatePostgresConfigResponse429 | v1UpdatePostgresConfigResponse500) & {
  headers: Headers;
};

export type v1UpdatePostgresConfigResponse = (v1UpdatePostgresConfigResponseSuccess | v1UpdatePostgresConfigResponseError)

export const getV1UpdatePostgresConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/database/postgres`
}

export const v1UpdatePostgresConfig = async (ref: string,
    updatePostgresConfigBody: UpdatePostgresConfigBody, options?: RequestInit): Promise<v1UpdatePostgresConfigResponse> => {
  
  return customFetch<v1UpdatePostgresConfigResponse>(getV1UpdatePostgresConfigUrl(ref),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePostgresConfigBody,)
  }
);}
  

/**
 * @summary Lists all backups
 */
export type v1ListAllBackupsResponse200 = {
  data: V1BackupsResponse
  status: 200
}

export type v1ListAllBackupsResponse401 = {
  data: void
  status: 401
}

export type v1ListAllBackupsResponse403 = {
  data: void
  status: 403
}

export type v1ListAllBackupsResponse429 = {
  data: void
  status: 429
}

export type v1ListAllBackupsResponse500 = {
  data: void
  status: 500
}

export type v1ListAllBackupsResponseSuccess = (v1ListAllBackupsResponse200) & {
  headers: Headers;
};
export type v1ListAllBackupsResponseError = (v1ListAllBackupsResponse401 | v1ListAllBackupsResponse403 | v1ListAllBackupsResponse429 | v1ListAllBackupsResponse500) & {
  headers: Headers;
};

export type v1ListAllBackupsResponse = (v1ListAllBackupsResponseSuccess | v1ListAllBackupsResponseError)

export const getV1ListAllBackupsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/backups`
}

export const v1ListAllBackups = async (ref: string, options?: RequestInit): Promise<v1ListAllBackupsResponse> => {
  
  return customFetch<v1ListAllBackupsResponse>(getV1ListAllBackupsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Restores a PITR backup for a database
 */
export type v1RestorePitrBackupResponse201 = {
  data: void
  status: 201
}

export type v1RestorePitrBackupResponse401 = {
  data: void
  status: 401
}

export type v1RestorePitrBackupResponse403 = {
  data: void
  status: 403
}

export type v1RestorePitrBackupResponse429 = {
  data: void
  status: 429
}

export type v1RestorePitrBackupResponseSuccess = (v1RestorePitrBackupResponse201) & {
  headers: Headers;
};
export type v1RestorePitrBackupResponseError = (v1RestorePitrBackupResponse401 | v1RestorePitrBackupResponse403 | v1RestorePitrBackupResponse429) & {
  headers: Headers;
};

export type v1RestorePitrBackupResponse = (v1RestorePitrBackupResponseSuccess | v1RestorePitrBackupResponseError)

export const getV1RestorePitrBackupUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/backups/restore-pitr`
}

export const v1RestorePitrBackup = async (ref: string,
    v1RestorePitrBody: V1RestorePitrBody, options?: RequestInit): Promise<v1RestorePitrBackupResponse> => {
  
  return customFetch<v1RestorePitrBackupResponse>(getV1RestorePitrBackupUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1RestorePitrBody,)
  }
);}
  

/**
 * @summary Initiates a creation of a restore point for a database
 */
export type v1CreateRestorePointResponse201 = {
  data: V1RestorePointResponse
  status: 201
}

export type v1CreateRestorePointResponse401 = {
  data: void
  status: 401
}

export type v1CreateRestorePointResponse403 = {
  data: void
  status: 403
}

export type v1CreateRestorePointResponse429 = {
  data: void
  status: 429
}

export type v1CreateRestorePointResponseSuccess = (v1CreateRestorePointResponse201) & {
  headers: Headers;
};
export type v1CreateRestorePointResponseError = (v1CreateRestorePointResponse401 | v1CreateRestorePointResponse403 | v1CreateRestorePointResponse429) & {
  headers: Headers;
};

export type v1CreateRestorePointResponse = (v1CreateRestorePointResponseSuccess | v1CreateRestorePointResponseError)

export const getV1CreateRestorePointUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/backups/restore-point`
}

export const v1CreateRestorePoint = async (ref: string,
    v1RestorePointPostBody: V1RestorePointPostBody, options?: RequestInit): Promise<v1CreateRestorePointResponse> => {
  
  return customFetch<v1CreateRestorePointResponse>(getV1CreateRestorePointUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1RestorePointPostBody,)
  }
);}
  

/**
 * @summary Get restore points for project
 */
export type v1GetRestorePointResponse200 = {
  data: V1RestorePointResponse
  status: 200
}

export type v1GetRestorePointResponse401 = {
  data: void
  status: 401
}

export type v1GetRestorePointResponse403 = {
  data: void
  status: 403
}

export type v1GetRestorePointResponse429 = {
  data: void
  status: 429
}

export type v1GetRestorePointResponse500 = {
  data: void
  status: 500
}

export type v1GetRestorePointResponseSuccess = (v1GetRestorePointResponse200) & {
  headers: Headers;
};
export type v1GetRestorePointResponseError = (v1GetRestorePointResponse401 | v1GetRestorePointResponse403 | v1GetRestorePointResponse429 | v1GetRestorePointResponse500) & {
  headers: Headers;
};

export type v1GetRestorePointResponse = (v1GetRestorePointResponseSuccess | v1GetRestorePointResponseError)

export const getV1GetRestorePointUrl = (ref: string,
    params?: V1GetRestorePointParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/projects/${ref}/database/backups/restore-point?${stringifiedParams}` : `/v1/projects/${ref}/database/backups/restore-point`
}

export const v1GetRestorePoint = async (ref: string,
    params?: V1GetRestorePointParams, options?: RequestInit): Promise<v1GetRestorePointResponse> => {
  
  return customFetch<v1GetRestorePointResponse>(getV1GetRestorePointUrl(ref,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Initiates an undo to a given restore point
 */
export type v1UndoResponse201 = {
  data: void
  status: 201
}

export type v1UndoResponse401 = {
  data: void
  status: 401
}

export type v1UndoResponse403 = {
  data: void
  status: 403
}

export type v1UndoResponse429 = {
  data: void
  status: 429
}

export type v1UndoResponseSuccess = (v1UndoResponse201) & {
  headers: Headers;
};
export type v1UndoResponseError = (v1UndoResponse401 | v1UndoResponse403 | v1UndoResponse429) & {
  headers: Headers;
};

export type v1UndoResponse = (v1UndoResponseSuccess | v1UndoResponseError)

export const getV1UndoUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/database/backups/undo`
}

export const v1Undo = async (ref: string,
    v1UndoBody: V1UndoBody, options?: RequestInit): Promise<v1UndoResponse> => {
  
  return customFetch<v1UndoResponse>(getV1UndoUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      v1UndoBody,)
  }
);}
  

